export default __webpack_public_path__ + "static/media/Princess.9aa6a248.png";